import { useMemo } from 'react';
import { Trans } from 'react-i18next';

import { CompensationType, Namespace } from 'enums';

import styles from './CompensationTypeHelper.module.scss';

export interface CompensationTypeHelperProps {
  type: CompensationType;
}

export const CompensationTypeHelper = ({ type }: CompensationTypeHelperProps) => {
  const compensationTypeHelpers = useMemo(
    () => [
      CompensationType.Sport,
      CompensationType.Robotics,
      CompensationType.Wedding,
      CompensationType.Children,
      CompensationType.FamilyFuneral,
    ],
    [],
  );

  return compensationTypeHelpers.includes(type) ? (
    <div className={styles.compensationTypeHelper}>
      <Trans
        i18nKey={type}
        ns={Namespace.CompensationTypesHelpers}
        components={{ paragraph: <p />, list: <ol />, listItem: <li /> }}
      />
    </div>
  ) : null;
};
